module.exports = __webpack_public_path__ + "static/media/bank-pf.24d758df.svg";